import Search from './Search.container';

export default Search;
